exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.backButton[data-v-879cb942] {\n  width: 18px;\n  height: 36px;\n}\n", "", {"version":3,"sources":["/newvolume/workspace/Prod/UI/lili-ui-partners-deploy/src/components/shared/template/templateDesktop.vue"],"names":[],"mappings":";AACA;EACE,YAAY;EACZ,aAAa;CACd","file":"templateDesktop.vue","sourcesContent":["\n.backButton[data-v-879cb942] {\n  width: 18px;\n  height: 36px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-879cb942","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/template/templateDesktop.vue
// module id = /Sjk
// module chunks = 27